import React, { useState } from 'react';
import properties from '../data/properties.json';
import PropertyCard from './PropertyCard';

const FILTERS = [
  { id: 'all', label: 'Todas las Propiedades' },
  { id: 'sale', label: 'En Venta' },
  { id: 'rent', label: 'En Alquiler' },
];

// Filtros + cuadrícula de propiedades. Se usa en la home y en /propiedades.
// priorityCount: cuántas tarjetas iniciales cargan su foto con prioridad (las visibles al abrir).
const PropertyFilterGrid = ({ priorityCount = 0 }) => {
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredProperties = activeFilter === 'all'
    ? properties
    : properties.filter((p) => p.type === activeFilter || p.type === 'both');

  return (
    <>
      <div className="property-filters">
        {FILTERS.map(({ id, label }) => (
          <button
            key={id}
            className={`filter-btn ${activeFilter === id ? 'active' : ''}`}
            onClick={() => setActiveFilter(id)}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="properties-grid">
        {filteredProperties.map((property, index) => (
          <PropertyCard key={property.id} property={property} priority={index < priorityCount} />
        ))}
      </div>
    </>
  );
};

export default PropertyFilterGrid;
